<template>
    <div>
      <div class="row settings-tabs full-height-tabs">
        <div class="col-lg-12 col-md-12">
          <vue-tabs
            ref="tabs"
            direction="vertical"
            class="row dispatch-tabs full-height-tabs items-align-dispatch-tabs text-align-dispatch-tabs"
            value="Description"
            @tab-change="handleTabChange"
          >
            <v-tab :title="$t('kds.kds')" class="text-left">
              <kds v-if="isKds" :isKds="isKds"></kds>
            </v-tab>
            <!-- <v-tab :title="$t('kds.report')" class="text-left">
              <kds-report v-if="isReport" :isReport="isReport"></kds-report>
            </v-tab> -->
            <v-tab :title="$t('kds.settings')" class="text-left">
              <kds-settings v-if="isSettings" :isSettings="isSettings" :openUsersProp="openUsers"></kds-settings>
            </v-tab>
          </vue-tabs>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Kds from './Kds.vue'
  import KdsSettings from './KdsSettings.vue'
  import KdsReport from './KdsReport.vue'
  export default {
    components: {
      Kds,
      KdsSettings,
      KdsReport
    },
    data () {
      return {
        isKds: false,
        isReport: false,
        isSettings: false,
        openUsers: false
      }
    },
    mounted () {
      console.log(this.$route.query.openUsers)
      if (this.$route.query.openUsers) {
        this.openUsers = true
      }
      this.switchTab()
    },
    methods: {
      resetStates () {
        this.isKds = false
        this.isOds = false
        this.isReport = false
        this.isSettings = false
        this.openUsers = false
      },
      switchTab () {
        const index = this.$route.query.tabIndex
        this.$nextTick(() => {
          if (index && this.$refs.tabs) {
            this.$refs.tabs.navigateToTab(parseInt(index))
          }
        })
      },
      handleTabChange (tabIndex, newTab, oldTab) {
        this.resetStates()
        this.$router.push(`${this.$route.path}?tabIndex=${tabIndex}`)
        switch (newTab.title) {
          case this.$t('pages.settings'):
            this.isSettings = true
            break
          // case this.$t('kds.report'):
          //   this.isReport = true
          //   break
          default:
            this.isKds = true
            break
        }
      }
    }
  }
  </script>
  


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Screens/Kds/KdsSidebar.vue